import LogRocket from 'logrocket';
import { version } from 'root/../package.json';
import { isProductionServer } from 'root/stores/routes/APP_URLS';
import { READ_USER_PROFILE } from 'root/stores/user';
import { FAILURE, SUCCESS } from 'utils/generateConstantLifecycle';
import userName from 'utils/userName';

export default {
  getMiddleware: () => () => {
    // init logrocket account if we are not in a dev env
    if (process.env.NODE_ENV === 'production' && isProductionServer)
      LogRocket.init('mswjo7/v2', { release: version });

    return (next) => (action) => {
      const { error, payload, type } = action;

      // don't do any of this tracking stuff if we are on a local dev env
      if (process.env.NODE_ENV !== 'production' || !isProductionServer)
        return next(action);

      try {
        const { icon, ...data } = { ...payload };

        // Send handled errors to logrocket
        if (error) LogRocket.captureException(error);

        // Send errors to logrocket that came from a catch without an error object
        if (!error && type.endsWith(`_${FAILURE}`))
          LogRocket.captureMessage(payload);

        switch (type) {
          case `${READ_USER_PROFILE}_${SUCCESS}`:
            // identify user
            LogRocket.identify(data.id, { ...data, name: userName(data) });
            break;
          default:
            return next(action);
        }
        return next(action);
      } catch (err) {
        return next(action);
      }
    };
  },
  name: 'logrocket',
};
